import found1 from '../images/foundation-1.png';
import found2 from '../images/foundation-2.png';
import found3 from '../images/foundation-3.png';
import found4 from '../images/foundation-4.png';
import found5 from '../images/foundation-5.png';
import found6 from '../images/foundation-6.png';
import found7 from '../images/foundation-7.png';
import found8 from '../images/foundation-8.png';
import found9 from '../images/foundation-9.png';

export const funds = [
    {
      title: 'Save the Children',
      url: 'https://www.savethechildren.net/what-we-do/emergencies/ukraine-crisis',
      img: found1,
    },
    {
      title: 'Project HOPE',
      url: 'https://www.projecthope.org/country/ukraine/',
      img: found2,
    },
    {
      title: 'International Medical Corps',
      url: 'https://internationalmedicalcorps.org/country/ukraine/',
      img: found3,
    },
    {
      title: 'RAZOM',
      url: 'https://www.razomforukraine.org/',
      img: found4,
    },
    {
      title: 'Action against hunger',
      url: 'https://www.actionagainsthunger.org/location/europe/ukraine/',
      img: found5,
    },
    {
      title: 'Serhiy Prytula Charity Foundation',
      url: 'https://prytulafoundation.org/en',
      img: found6,
    },
    {
      title: 'UNITED24',
      url: 'https://u24.gov.ua/uk',
      img: found7,
    },
    {
      title: 'World vision',
      url: 'https://www.wvi.org/emergencies/ukraine',
      img: found8,
    },
    {
      title: 'Medicins Sans   Frontieres',
      url: 'https://www.msf.org/ukraine',
      img: found9,
    },
];